import { useMutation } from '@tanstack/react-query';
import { sendFormAnswer } from 'app/services/liveChat';
import useFetchHelpCenter from 'app/hooks/fetch/useFetchHelpCenter';

import { AnswerResponse, handleMutationSuccess } from './mutationSuccessHandler';

export default function useFetchFormAnswer() {
  const { data: helpCenter } = useFetchHelpCenter();
  const uuid = helpCenter?.uuid;
  const queryKey = ['liveChat', uuid];

  return useMutation({
    mutationFn: (data) => sendFormAnswer<AnswerResponse>({ uuid, data }),
    onSuccess: handleMutationSuccess(queryKey),
  });
}
